import api from "../api";
import {createError, logError, logSuccess, buildMessageFromResponse} from "./message";
import types from "./types";

import {getRequestSystemInfo,
  getRequestMainInfo,
  getRequestCard,
  getRequestProgramCard,
  getRequestGroupCard} from "./actions";

function requestChangeState() {
  return {
    type: types.CHANGE_WORK_STATE_REQUEST,
    isFetchingWorkProcess: true
  };
}

function requestChangeStateCompleted(workProcess) {
  return {
    type: types.CHANGE_WORK_STATE_COMPLETED,
    isFetchingWorkProcess: false,
    workProcess
  };
}

function requestChangeStateError(workProcessError) {
  return {
    type: types.CHANGE_WORK_STATE_ERROR,
    isFetchingWorkProcess: false,
    workProcessError
  };
}

export function sendRequestToWork(requestId) {
  return dispatch => {
    dispatch(requestChangeState());
    return api.sendToWork(requestId)
      .then(response => {
        if (response.status === 200) {
          dispatch(requestChangeStateCompleted(response.data));
          dispatch(getRequestSystemInfo(requestId));
          dispatch(getRequestMainInfo(requestId));
          dispatch(getRequestCard(requestId));
        } else {
          return Promise.reject(response);
        }
        return Promise.resolve();
      })
      .catch(err => {
        if (err.response && err.response.status === 400) {
          let message = buildMessageFromResponse(err.response);
          logError(message);
          dispatch(requestChangeStateError(message));
        } else {
          logError(err);
          dispatch(requestChangeStateError(createError("Не удалось изменить статус заявки")));
        }
      });
  };
}

export function sendRequestToApprove(requestId, comment) {
  return dispatch => {
    dispatch(requestChangeState());
    return api.sendToApprove(requestId, comment)
      .then(response => {
        if (response.status === 200) {
          dispatch(requestChangeStateCompleted(response.data));
          dispatch(getRequestSystemInfo(requestId));
          dispatch(getRequestMainInfo(requestId));
          dispatch(getRequestCard(requestId));
        } else {
          return Promise.reject(response);
        }
        return Promise.resolve();
      })
      .catch(err => {
        if (err.response && err.response.status === 400) {
          let message = buildMessageFromResponse(err.response);
          logError(message);
          dispatch(requestChangeStateError(message));
        } else {
          logError(err);
          dispatch(requestChangeStateError(createError("Не удалось подтвердить заявку")));
        }
      });
  };
}

export function sendRequestToApproveMany(requests, groupId, newGroupData) {
  return dispatch => {
    dispatch(requestChangeState());
    return api.sendToApproveMany(requests, groupId, newGroupData)
      .then(response => {
        if (response.status === 200) {
          console.log(response.data);
          dispatch(requestChangeStateCompleted(response.data));
        } else {
          return Promise.reject(response);
        }
        return Promise.resolve();
      })
      .catch(err => {
        if (err.response && err.response.status === 400) {
          let message = buildMessageFromResponse(err.response);
          dispatch(requestChangeStateError(message));
        } else {
          dispatch(requestChangeStateError(createError("Не удалось подтвердить заявки")));
        }
      });
  };
}

export function sendRequestToDecline(requestId, comment) {
  return dispatch => {
    dispatch(requestChangeState());
    return api.sendToDecline(requestId, comment)
      .then(response => {
        if (response.status === 200) {
          dispatch(requestChangeStateCompleted(response.data));
          dispatch(getRequestSystemInfo(requestId));
          dispatch(getRequestMainInfo(requestId));
          dispatch(getRequestCard(requestId));
        } else {
          return Promise.reject(response);
        }
        return Promise.resolve();
      })
      .catch(err => {
        if (err.response && err.response.status === 400) {
          let message = buildMessageFromResponse(err.response);
          logError(message);
          dispatch(requestChangeStateError(message));
        } else {
          logError(err);
          dispatch(requestChangeStateError(createError("Не удалось отклонить заявку")));
        }
      });
  };
}

export function sendRequestToDeclineMany(requests, comment) {
  return dispatch => {
    dispatch(requestChangeState());
    return api.sendToDeclineMany(requests, comment)
      .then(response => {
        if (response.status === 200) {
          dispatch(requestChangeStateCompleted(response.data));
        } else {
          return Promise.reject(response);
        }
        return Promise.resolve();
      })
      .catch(err => {
        if (err.response && err.response.status === 400) {
          let message = buildMessageFromResponse(err.response);
          dispatch(requestChangeStateError(message));
        } else {
          dispatch(requestChangeStateError(createError("Не удалось отклонить заявки")));
        }
      });
  };
}

export function sendRequestToArchive(requestId) {
  return dispatch => {
    dispatch(requestChangeState());
    return api.sendToArchive(requestId)
      .then(response => {
        if (response.status === 200) {
          dispatch(requestChangeStateCompleted(response.data));
          dispatch(getRequestSystemInfo(requestId));
          dispatch(getRequestMainInfo(requestId));
          dispatch(getRequestCard(requestId));
        } else {
          return Promise.reject(response);
        }
        return Promise.resolve();
      })
      .catch(err => {
        if (err.response && err.response.status === 400) {
          let message = buildMessageFromResponse(err.response);
          logError(message);
          dispatch(requestChangeStateError(message));
        } else {
          logError(err);
          dispatch(requestChangeStateError(createError("Не удалось отправить заявку в архив")));
        }
      });
  };
}

/*function requestSetPlan() {
  return {
    type: types.SET_REQUEST_PLAN_REQUEST,
    isFetchingWorkProcess: true
  };
}

function requestSetPlanCompleted(workProcess) {
  return {
    type: types.SET_REQUEST_PLAN_COMPLETED,
    isFetchingWorkProcess: false,
    workProcess
  };
}

function requestSetPlanError(workProcessError) {
  return {
    type: types.SET_REQUEST_PLAN_ERROR,
    isFetchingWorkProcess: false,
    workProcessError
  };
}

export function setRequestPlan(requestId, planId) {
  return dispatch => {
    dispatch(requestSetPlan());
    return api.setPlan(requestId, planId)
      .then(response => {
        if (response.status === 200) {
          dispatch(requestSetPlanCompleted(response.data));
          dispatch(getRequestSystemInfo(requestId));
          dispatch(getRequestMainInfo(requestId));
          dispatch(getRequestCard(requestId));
          dispatch(getRequestProgramCard(requestId));
          dispatch(getRequestGroupCard(requestId));
        } else {
          return Promise.reject(response);
        }
        return Promise.resolve();
      })
      .catch(err => {
        if (err.response && err.response.status === 400) {
          let message = err.response;
          if (err.response.data && err.response.data.errors) {
            message = err.response.data.errors.map(({message}) => message).join(", ");
          }
          logError(message);
          dispatch(requestSetPlanError(message));
        } else {
          logError(err);
          dispatch(requestSetPlanError(createError("Не удалось изменить учебный план")));
        }
      });
  };
}*/

function requestSetGroup() {
  return {
    type: types.SET_REQUEST_GROUP_REQUEST,
    isFetchingWorkProcess: true
  };
}

function requestSetGroupCompleted(workProcess) {
  return {
    type: types.SET_REQUEST_GROUP_COMPLETED,
    isFetchingWorkProcess: false,
    workProcess
  };
}

function requestSetGroupError(workProcessError) {
  return {
    type: types.SET_REQUEST_GROUP_ERROR,
    isFetchingWorkProcess: false,
    workProcessError
  };
}

export function setRequestGroup(requestId, groupId, newGroupData) {
  return dispatch => {
    dispatch(requestSetGroup());
    return api.setGroup(requestId, groupId, newGroupData)
      .then(response => {
        if (response.status === 200) {
          dispatch(requestSetGroupCompleted(response.data));
          dispatch(getRequestSystemInfo(requestId));
          dispatch(getRequestMainInfo(requestId));
          dispatch(getRequestCard(requestId));
          dispatch(getRequestProgramCard(requestId));
          dispatch(getRequestGroupCard(requestId));
        } else {
          return Promise.reject(response);
        }
        return Promise.resolve();
      })
      .catch(err => {
        if (err.response && err.response.status === 400) {
          let message = buildMessageFromResponse(err.response);
          logError(message);
          dispatch(requestSetGroupError(message));
        } else {
          logError(err);
          dispatch(requestSetGroupError(createError("Не удалось изменить группу")));
        }
      });
  };
}

function requestSetPerson() {
  return {
    type: types.SET_REQUEST_PERSON_REQUEST,
    isFetchingWorkProcess: true
  };
}

function requestSetPersonCompleted(workProcess) {
  return {
    type: types.SET_REQUEST_PERSON_COMPLETED,
    isFetchingWorkProcess: false,
    workProcess
  };
}

function requestSetPersonError(workProcessError) {
  return {
    type: types.SET_REQUEST_PERSON_ERROR,
    isFetchingWorkProcess: false,
    workProcessError
  };
}

export function setRequestPerson(requestId, personId) {
  return dispatch => {
    dispatch(requestSetPerson());
    return api.setPerson(requestId, personId)
      .then(response => {
        if (response.status === 200) {
          dispatch(requestSetPersonCompleted(response.data));
          dispatch(getRequestSystemInfo(requestId));
          dispatch(getRequestMainInfo(requestId));
        } else {
          return Promise.reject(response);
        }
        return Promise.resolve();
      })
      .catch(err => {
        if (err.response && err.response.status === 400) {
          let message = buildMessageFromResponse(err.response);
          logError(message);
          dispatch(requestSetPersonError(message));
        } else {
          logError(err);
          dispatch(requestSetPersonError(createError("Не удалось изменить связь с заявителем")));
        }
      });
  };
}

function requestSetStudent() {
  return {
    type: types.SET_REQUEST_STUDENT_REQUEST,
    isFetchingWorkProcess: true
  };
}

function requestSetStudentCompleted(workProcess) {
  return {
    type: types.SET_REQUEST_STUDENT_COMPLETED,
    isFetchingWorkProcess: false,
    workProcess
  };
}

function requestSetStudentError(workProcessError) {
  return {
    type: types.SET_REQUEST_STUDENT_ERROR,
    isFetchingWorkProcess: false,
    workProcessError
  };
}

export function setRequestStudent(requestId, personId) {
  return dispatch => {
    dispatch(requestSetStudent());
    return api.setStudent(requestId, personId)
      .then(response => {
        if (response.status === 200) {
          dispatch(requestSetStudentCompleted(response.data));
          dispatch(getRequestSystemInfo(requestId));
          dispatch(getRequestMainInfo(requestId));
        } else {
          return Promise.reject(response);
        }
        return Promise.resolve();
      })
      .catch(err => {
        if (err.response && err.response.status === 400) {
          let message = buildMessageFromResponse(err.response);
          logError(message);
          dispatch(requestSetStudentError(message));
        } else {
          logError(err);
          dispatch(requestSetStudentError(createError("Не удалось изменить связь с обучающимся")));
        }
      });
  };
}

function requestCreateStudent() {
  return {
    type: types.CREATE_REQUEST_STUDENT_REQUEST,
    isCreatingStudent: true
  };
}

function requestCreateStudentCompleted(createdStudent) {
  return {
    type: types.CREATE_REQUEST_STUDENT_COMPLETED,
    isCreatingStudent: false,
    createdStudent
  };
}

function requestCreateStudentError(createStudentError) {
  return {
    type: types.CREATE_REQUEST_STUDENT_ERROR,
    isCreatingStudent: false,
    createStudentError
  };
}

export function createRequestStudent(data) {
  return dispatch => {
    dispatch(requestCreateStudent());
    return api.createRequestStudent(data)
      .then(response => {
        if (response.status === 200) {
          let resp = response.data;
          dispatch(requestCreateStudentCompleted(resp));
        } else {
          return Promise.reject(response);
        }
        return Promise.resolve();
      })
      .catch(err => {
        if (err.response && err.response.status === 400) {
          let message = buildMessageFromResponse(err.response);
          logError(message);
          dispatch(requestCreateStudentError(message));
        } else {
          logError(err);
          dispatch(requestCreateStudentError(createError("Не удалось создать запись")));
        }
      });
  };
}

function requestCreatePerson() {
  return {
    type: types.CREATE_REQUEST_PERSON_REQUEST,
    isCreatingPerson: true
  };
}

function requestCreatePersonCompleted(createdPerson) {
  return {
    type: types.CREATE_REQUEST_PERSON_COMPLETED,
    isCreatingPerson: false,
    createdPerson
  };
}

function requestCreatePersonError(createPersonError) {
  return {
    type: types.CREATE_REQUEST_PERSON_ERROR,
    isCreatingPerson: false,
    createPersonError
  };
}

export function createRequestPerson(data) {
  return dispatch => {
    dispatch(requestCreatePerson());
    return api.createRequestPerson(data)
      .then(response => {
        if (response.status === 200) {
          let resp = response.data;
          dispatch(requestCreatePersonCompleted(resp));
        } else {
          return Promise.reject(response);
        }
        return Promise.resolve();
      })
      .catch(err => {
        if (err.response && err.response.status === 400) {
          let message = buildMessageFromResponse(err.response);
          logError(message);
          dispatch(requestCreatePersonError(message));
        } else {
          logError(err);
          dispatch(requestCreatePersonError(createError("Не удалось создать запись")));
        }
      });
  };
}

function requestSetProgram() {
  return {
    type: types.SET_REQUEST_PROGRAM_REQUEST,
    isFetchingWorkProcess: true
  };
}

function requestSetProgramCompleted(workProcess) {
  return {
    type: types.SET_REQUEST_PROGRAM_COMPLETED,
    isFetchingWorkProcess: false,
    workProcess
  };
}

function requestSetProgramError(workProcessError) {
  return {
    type: types.SET_REQUEST_PROGRAM_ERROR,
    isFetchingWorkProcess: false,
    workProcessError
  };
}

export function setRequestProgram(requestId, programId) {
  return dispatch => {
    dispatch(requestSetProgram());
    return api.setProgram(requestId, programId)
      .then(response => {
        if (response.status === 200) {
          dispatch(requestSetProgramCompleted(response.data));
          logSuccess("Учебная программа изменена");
          dispatch(getRequestSystemInfo(requestId));
          dispatch(getRequestMainInfo(requestId));
          dispatch(getRequestCard(requestId));
          dispatch(getRequestProgramCard(requestId));
          dispatch(getRequestGroupCard(requestId));
        } else {
          return Promise.reject(response);
        }
        return Promise.resolve();
      })
      .catch(err => {
        if (err.response && err.response.status === 400) {
          let message = buildMessageFromResponse(err.response);
          logError(message);
          dispatch(requestSetProgramError(message));
        } else {
          logError(err);
          dispatch(requestSetProgramError(createError("Не удалось изменить программу обучения")));
        }
      });
  };
}

function requestCalculateSimilar() {
  return {
    type: types.CALCULATE_REQUEST_SIMILAR_REQUEST,
    isCalculatingSimilarRequest: true
  };
}

function requestCalculateSimilarCompleted(calcSimilarResult) {
  return {
    type: types.CALCULATE_REQUEST_SIMILAR_COMPLETED,
    isCalculatingSimilarRequest: false,
    calcSimilarResult
  };
}

function requestCalculateSimilarError(calcSimilarError) {
  return {
    type: types.CALCULATE_REQUEST_SIMILAR_ERROR,
    isCalculatingSimilarRequest: false,
    calcSimilarError
  };
}

export function calculateSimilarRequests() {
  return dispatch => {
    dispatch(requestCalculateSimilar());
    return api.calcSimilarRecords()
      .then(response => {
        if (response.status === 200) {
          dispatch(requestCalculateSimilarCompleted(response.data));
          logSuccess("Проверка дублирующих записей прошла успешно");
        } else {
          return Promise.reject(response);
        }
        return Promise.resolve();
      })
      .catch(err => {
        if (err.response && err.response.status === 400) {
          let message = buildMessageFromResponse(err.response);
          logError(message);
          dispatch(requestCalculateSimilarError(message));
        } else {
          logError(err);
          dispatch(requestCalculateSimilarError(createError("Не удалось сделать проверку")));
        }
      });
  };
}

function requestCreateRequestProgram() {
  return {
    type: types.CREATE_REQUEST_PROGRAM_REQUEST,
    isCreatingRequestProgram: true
  };
}

function requestCreateRequestProgramCompleted(createdRequestProgram) {
  return {
    type: types.CREATE_REQUEST_PROGRAM_COMPLETED,
    isCreatingRequestProgram: false,
    createdRequestProgram
  };
}

function requestCreateRequestProgramError(createRequestProgramError) {
  return {
    type: types.CREATE_REQUEST_PROGRAM_ERROR,
    isCreatingRequestProgram: false,
    createRequestProgramError
  };
}

export function createRequestProgram(data) {
  return dispatch => {
    dispatch(requestCreateRequestProgram());
    return api.createRequest(data)
      .then(response => {
        if (response.status === 200) {
          let resp = response.data;
          dispatch(requestCreateRequestProgramCompleted(resp));
        } else {
          return Promise.reject(response);
        }
        return Promise.resolve();
      })
      .catch(err => {
        if (err.response && err.response.status === 400) {
          let message = buildMessageFromResponse(err.response);
          logError(message);
          dispatch(requestCreateRequestProgramError(message));
        } else {
          logError(err);
          dispatch(requestCreateRequestProgramError(createError("Не удалось создать заявку на обучение")));
        }
      });
  };
}

export default {
  sendRequestToWork,
  sendRequestToApprove,
  sendRequestToApproveMany,
  sendRequestToDeclineMany,
  sendRequestToDecline,
  sendRequestToArchive,
  setRequestProgram,
  setRequestGroup,
  setRequestPerson,
  setRequestStudent,
  createRequestProgram,
  createRequestPerson,
  createRequestStudent,
  calculateSimilarRequests
}
